import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tokens.css";
import "./styles/app.css";

// Printed once at startup so a stale build is obvious rather than mysterious.
console.info("FrontLot build 2026-09-03-m — crop matches the guide");

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
